import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { AppDispatch, RootState } from "../store/store";
import {
  getAllCreators,
  selectAllCreators,
  selectAllCreatorsLoading,
} from "../store/discoverSlice";
import LoadingIndicator from "../components/ui/LoadingIndicator";
import { Award } from "lucide-react";
import { motion } from "framer-motion";
import { toggleFollowCreator } from "../store/dreamworldSlice";
import PageLayout from "../components/ui/PageLayout";

const AllCreatorsPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const creators = useSelector(selectAllCreators);
  const loading = useSelector(selectAllCreatorsLoading);
  const userGlobalData = useSelector(
    (state: RootState) => state.dreamworld.userGlobalData
  );

  useEffect(() => {
    dispatch(getAllCreators());
  }, [dispatch]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-purple-950 to-slate-900 text-white">
      <PageLayout>
        <h1 className="text-4xl font-bold mb-8">All Creators</h1>
        {loading === "pending" ? (
          <div className="flex items-center justify-center w-full p-6">
            <LoadingIndicator />
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {creators.map((creator) => (
              <Link to={`/profile/${creator.uid}`} key={creator.uid}>
                <motion.div className="bg-gradient-to-br from-gray-800/80 to-gray-900/80 backdrop-blur-sm rounded-xl p-4 border border-gray-700/50 hover:border-purple-500/30 transition-all cursor-pointer text-center group">
                  <div className="relative inline-block mb-3">
                    <img
                      src={
                        creator.avatarUrl ||
                        "https://plus.unsplash.com/premium_photo-1673697239981-389164b7b87f?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8bmF0dXJlfGVufDB8fDB8fHww"
                      }
                      alt={creator.username}
                      className="w-24 h-24 rounded-full mx-auto object-cover ring-2 ring-purple-500/30 group-hover:ring-purple-500/60 transition-all"
                    />
                    {true && (
                      <div className="absolute -top-1 -right-1 bg-blue-500 rounded-full p-0.5">
                        <Award className="w-4 h-4 text-white" />
                      </div>
                    )}
                  </div>
                  <h3 className="text-white font-semibold text-lg mb-2">
                    {creator.username}
                  </h3>
                  <p className="text-gray-400 text-sm mb-4">
                    {creator.generationCount || 0} Generations
                  </p>
                  {userGlobalData?.user?.uid !== creator.uid && (
                    <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={(e) => {
                        e.preventDefault();
                        if (userGlobalData) {
                          dispatch(
                            toggleFollowCreator({
                              currentUserId: userGlobalData.user.uid,
                              creatorId: creator.uid,
                            })
                          );
                        }
                      }}
                      className={`w-full py-1.5 rounded-md text-sm font-medium transition-colors ${
                        userGlobalData?.userData?.following?.includes(
                          creator.uid
                        )
                          ? "bg-purple-600 text-white"
                          : "bg-gray-700 text-white hover:bg-purple-600"
                      }`}
                    >
                      {userGlobalData?.userData?.following?.includes(
                        creator.uid
                      )
                        ? "Following"
                        : "Follow"}
                    </motion.button>
                  )}
                </motion.div>
              </Link>
            ))}
          </div>
        )}
      </PageLayout>
    </div>
  );
};

export default AllCreatorsPage;
